<template>
    <div class="index">
        <el-container>
            <el-header class="topBackground" height="0.65rem">
                <headers></headers>
            </el-header>
            <el-container>
                <el-aside  class="leftBackground" style="width:auto">
                    <left></left>
                </el-aside>
                <el-main>
                    <!--router tab-->
                    <page-tab></page-tab>
                    <div class="content-box">
                        <transition name="fade" mode="out-in">
                            <router-view v-if="alive"></router-view>
                        </transition>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import headers from "../components/header";
import left from "../components/left.vue";
import pageTab from "../components/pageTab.vue";
import bus from "../libs/bus";
import { get, post, ws_URL } from "../libs/tool";
export default {
    name: "index",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            msg: "路由承接页",
            // LeftWidth: "180px",
            alive: true,
            currentLoginName: "", //当前登录用户
            tid: "",

            setRuleShow: false, //体温
            setRuleShow2: false, //在离家
            setRuleShow3: false, //血压
            setRuleShow4: false, //心率
            setRuleShow5: false, //sos
            setRuleShow6: false, //跌倒
            setRuleShow7: false, //电子围栏
            setRuleShow8: false, //特殊提醒
            setRuleShow9: false, //烟感提醒
            setRuleShow10: false, //运动心率

            // 异常预警警报
            abnormalUser: "", //用户名
            phoneNum: "", //联系电话
            abnormalTime: "", //发生时间
            abnormalTemperature: "", //异常体温值
            abnormalLocation: "", //发生位置
            //体温异常预警弹窗的信息
            temperatureInfo: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                temperature: "",
                address: "",
            },
            // 在离家弹窗信息
            suspectedToHomeInfo: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                address: "",
            },
            // 血压异常弹窗信息
            dysarteriotony: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                sbp: "",
                dbp: "",
            },
            // 心率异常弹窗信息
            abnormalities: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                heartrate: "",
            },
            // sos弹窗信息
            SOSemergency: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                address: "",
            },
            // 跌倒
            fallWarning: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                address: "",
            },
            // 电子围栏
            fenceWarning: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                address: "",
            },
            //特殊提醒异常预警弹窗的信息
            SpecialRemindInfo: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                alertText: "",
                address: "",
            },
            //烟感预警弹窗的信息
            NtwarningInfo: {
                imei: "",
                organization: {
                    name: "",
                },
                time_begin: "",
                alarm_desc: "",
                building: {
                    name: "",
                },
                floor: {
                    floor_no: "",
                },
                room: {
                    room_no: "",
                },
                cell: {
                    cell_no: "",
                },
            },
            // 运动心率
            EXSwarningInfo: {
                owner: {
                    name: "",
                    mobile_phone: "",
                },
                time_begin: "",
                address: "",
            },
            auth: "",
            socket: "",
        };
    },
    components: { headers, left, pageTab },
    mounted() {
        let that = this;
        let auth = localStorage.getItem("auth");
        this.$nextTick(function () {
            //有缓存就取缓存

            if (auth != "null") {
                //          console.log(auth)
                auth = typeof auth == "object" ? auth : JSON.parse(auth);

                that.$store.commit("change_auth", auth);
            }

            //根据不同的返回orginId加载不同的styl
            //2c928efd6657fa51016665f570180001
            if (auth.organization.id == "000000006b6d88bc016c4ac8f22914bf") {
                console.log("加载css");
                $("#styles").attr("href", "./static/css/bb.css");
            }
        });
        auth = typeof auth == "object" ? auth : JSON.parse(auth);
        this.auth = auth;
        bus.$on("aacc", function () {
            console.log("我切换了003");
            that.alive = false;
            that.$nextTick(() => {
                that.alive = true;
            });
        });
        // this.socketInit();
        if (localStorage.getItem("createLogin") == 1) {
            localStorage.removeItem("createLogin");
            this.$router.go(0);
        }
    },
    methods: {
        processing(num) {
            if (num == 1) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow = false;
            }
            if (num == 2) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow2 = false;
            }
            if (num == 3) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow3 = false;
            }
            if (num == 4) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow4 = false;
            }
            if (num == 5) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow5 = false;
            }
            if (num == 6) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow6 = false;
            }
            if (num == 7) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow7 = false;
            }
            if (num == 8) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow8 = false;
            }
            if (num == 9) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow9 = false;
            }
            if (num == 10) {
                this.$router.push("/index/warningDeal");
                this.setRuleShow10 = false;
            }
        },
        reload() {
            let that = this;
            this.alive = false;
            this.$nextTick(function () {
                that.alive = true;
            });
        },
        //初始化websocket
        socketInit() {
            let that = this;
            let loginid = this.auth.id;
            // console.log("loginid001", loginid);

            let ws = new WebSocket(
                "ws://" +
                    ws_URL +
                    "/smart-care/chat?" +
                    loginid +
                    "_" +
                    that.auth.organization.id
            );

            this.socket = ws;

            //连接成功
            ws.onopen = function () {
                console.log("头部连接成功");

                //that.socket.send('{"message":"loginid_organ", "loginId":"'+ that.currentLoginId +'", "organId":"' + that.auth.organ_id + '"}')

                //添加防超时逻辑
                //          that.checkTimeOut();
            };

            //接受服务器端信息回调
            ws.onmessage = function (res) {
                //   console.log('接受服务器端信息回调', res);

                let dat =
                    typeof res.data === "object"
                        ? res.data
                        : JSON.parse(res.data);

                console.log("接受服务器端信息回调", dat);
                console.log("信息", dat.message, dat.type);
                //接入大屏退出会重置登录信息的bug
                // if (
                //     dat.type == "kickOut" &&
                //     that.$route.path !== "/index/bigScreen"
                // ) {
                //     console.log(dat);
                //     console.log("请重新登录");
                //     that.$message({
                //         message: "该用户已在其他地方登陆，请重新登录",
                //         type: "success",
                //     });

                //     let gid =
                //         that.auth.organization.id ==
                //         "000000006e90c1f7016ea5a5d95600c2"
                //             ? "huiming"
                //             : that.auth.organization.id ==
                //               "0000000072f21ef4017303b86f0e000a"
                //             ? "jianggou"
                //             : that.auth.organization.id ==
                //               "00000000735c100401735c1802b70001"
                //             ? "hualing"
                //             : "";
                //     // localStorage.removeItem('auth')
                //     that.$router.push({
                //         name: "login",
                //         query: {
                //             gid: gid,
                //         },
                //     });
                // }

                // if((dat.message && (dat.type == 'kickOut')) && (that.currentLoginName == dat.loginName)){
                // if (dat.data.channel == "KICKOUT_CHANNEL") {
                //     console.log("退出登录");

                //     if (that.jsonData.oem.tag) {
                //         that.$router.push({
                //             name: "login",
                //             query: { tag: that.jsonData.oem.tag },
                //         });
                //     } else {
                //         that.$router.push({ name: "login" });
                //     }
                //     //挤出登录信息
                //     localStorage.setItem("kickOut", JSON.stringify(dat.data));
                // }

                let falg = false;
                if (that.auth.grade == 1 && dat.data.organization) {
                    if (dat.data.organization.id == that.auth.organization.id) {
                        falg = true;
                    } else {
                        falg = false;
                    }
                }
                if (that.auth.grade == 2 && dat.data.community) {
                    if (
                        dat.data.organization.id == that.auth.organization.id &&
                        dat.data.community.id == that.auth.community.id
                    ) {
                        falg = true;
                    } else {
                        falg = false;
                    }
                }
                if (that.auth.grade == 3 && dat.data.sub) {
                    if (
                        dat.data.organization.id == that.auth.organization.id &&
                        dat.data.community.id == that.auth.community.id &&
                        dat.data.sub.id == that.auth.sub.id
                    ) {
                        falg = true;
                    } else {
                        falg = false;
                    }
                }

                if (dat.data && falg) {
                    // 如果是这个类型，是sos紧急呼叫
                    if (dat.data.channel == "SOS_CHANNEL") {
                        let queryData = {
                            address: dat.data.address,
                            city: dat.data.city,
                            is_disposed: dat.data.is_disposed,
                            time_begin: dat.data.time_begin,
                            imei: dat.data.imei,
                            lon: dat.data.lon,
                            type: dat.data.type,
                            lat: dat.data.lat,
                            organ_id: dat.data.organization.id,
                            user_name: dat.data.owner
                                ? dat.data.owner.name
                                    ? dat.data.owner.name
                                    : ""
                                : "",
                            user_phone: dat.data.owner
                                ? dat.data.owner.mobile_phone
                                    ? dat.data.owner.mobile_phone
                                    : ""
                                : "",
                        };
                        let routeData = that.$router.resolve({
                            name: "detailMap",
                            query: queryData,
                        });
                        window.open(
                            routeData.href,
                            "_blank",
                            "height=620, width=1100, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
                        );

                        that.SOSemergency = {};
                        that.setRuleShow5 = true;
                        that.SOSemergency = dat.data;
                    } else if (dat.data.channel == "TEMPERATURE_CHANNEL") {
                        that.temperatureInfo = {};
                        console.log("我异常了");
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_temperature_enable == 1
                        ) {
                            that.setRuleShow = true;
                        }

                        that.temperatureInfo = dat.data;
                        console.log("弹窗数据", that.temperatureInfo);
                    } else if (dat.data.channel == "WIFIHOME_CHANNEL") {
                        that.suspectedToHomeInfo = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_wifihome_enable == 1
                        ) {
                            that.setRuleShow2 = true;
                        }
                        that.suspectedToHomeInfo = dat.data;
                        console.log("弹窗数据", that.suspectedToHomeInfo);
                    } else if (dat.data.channel == "BLOODPRESSURE_CHANNEL") {
                        that.dysarteriotony = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_bloodpressure_enable == 1
                        ) {
                            that.setRuleShow3 = true;
                        }
                        that.dysarteriotony = dat.data;
                        console.log("弹窗数据", that.dysarteriotony);
                    } else if (dat.data.channel == "HEARTRATE_CHANNEL") {
                        that.abnormalities = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_heartrate_enable == 1
                        ) {
                            that.setRuleShow4 = true;
                        }
                        that.abnormalities = dat.data;
                        console.log("弹窗数据", that.abnormalities);
                    } else if (dat.data.channel == "FALL_CHANNEL") {
                        that.fallWarning = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_fall_enable == 1
                        ) {
                            that.setRuleShow6 = true;
                        }
                        that.fallWarning = dat.data;
                        console.log("弹窗数据", that.fallWarning);
                    } else if (dat.data.channel == "FENCE_CHANNEL") {
                        that.fenceWarning = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_fence_enable == 1
                        ) {
                            that.setRuleShow7 = true;
                        }
                        that.fenceWarning = dat.data;
                        console.log("弹窗数据", that.fenceWarning);
                    } else if (dat.data.channel == "ALERT_REPLY_CHANNEL") {
                        that.SpecialRemindInfo = {};
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_alertreply_enable == 1
                        ) {
                            that.setRuleShow8 = true;
                        }
                        that.SpecialRemindInfo = dat.data;
                        console.log("弹窗数据", that.SpecialRemindInfo);
                    } else if (dat.data.channel == "SMOKE_DETECTOR_CHANNEL") {
                        that.setRuleShow9 = true;
                        that.NtwarningInfo = dat.data;
                        console.log(that.NtwarningInfo, "烟感弹窗数据");
                    } else if (
                        dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL"
                    ) {
                        if (
                            that.auth.role.warning_show_type != 1 &&
                            !that.auth.role.is_super_administrator &&
                            that.auth.role.warning_exercise_heartrate_enable ==
                                1
                        ) {
                            that.EXSwarningInfo = dat.data;
                            that.setRuleShow10 = true;
                            console.log(
                                that.EXSwarningInfo,
                                "运动心率弹窗数据"
                            );
                        }
                    }
                }
            };
            //连接关闭回调
            ws.onclose = function () {
                console.log("连接关闭111111");
            };
            //连接出错
            ws.onerror = function () {
                console.log("连接出错");
            };
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
$color1 = red;

.fade-enter-active, .fade-leave-active {
    transition: all 0.2s ease;
}

.fade-enter, .fade-leave-active {
    opacity: 0;
    transform: translateX(10px);
}

.index {
    width: 100%;
    height: 100%;
}

.el-header {
    /* background-color: #242424 */
    color: #333;
    background-color: $color1;
    text-align: center;
    line-height: 0.65rem;
    padding: 0;
}

.el-aside {
    height: 100%;
    color: #333;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    // padding: 5px 0px 0px 0;
    position: relative;
    transition: all 0.3s;
}

.el-main {
    color: #333;
    text-align: center;
    padding: 0;
    margin: 0;
    position: relative;
    background: #f7f7f7;
    // background: red;
    border-top-left-radius: 4px;

    .content-box {
        width: 100%;
        box-sizing: border-box;
        height: calc(100% - 0.5rem);
        height: 100%;
        overflow: auto;
    }

    .breakNav {
        position: absolute;
        left: 20px;
        top: 20px;
        font-weight: bold;
    }
}

.el-container {
    height: 100%;

    >.el-container {
        height: calc(100% - 0.9rem);
        width: 100%;
        background: $color1;
    }
}

.home {
    width: 100%;
    height: 100%;
}

.dial-center {
    background: #ff7624;
    font-size: 18px;
    padding: 8px 24px;
    color: #fff;
    border-radius: 20px 0 20px 20px;
    cursor: pointer;
    height: 22px;
    line-height: 6px;
    position: absolute;
    top: 260px;
    left: -120px;
}

.dial-center {
    background: #ff7624;
    font-size: 18px;
    padding: 8px 24px;
    color: #fff;
    border-radius: 20px 0 20px 20px;
    cursor: pointer;
    height: 22px;
    line-height: 6px;
    position: absolute;
    top: 130px;
    left: -120px;
}
/deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
}

/deep/ .el-dialog__header {
    // padding: 20px;
    font-size: 16px;
    text-align: center;
    background: #ff6320;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    padding: 20px;
}

.service-title {
    position: absolute;
    top: 15px;
    color: #fff;
    text-align: center;
}

.order-data {
    .user-i-name {
        display: flex;
        align-items: center;
        margin: 35px 10px;
    }

    .u-i-left {
        margin-right: 10px;
        width: 100px;
        text-align: right;
    }

    .new-save {
        width: 200px;
        background: #ff7624;
        text-align: center;
        margin: 40px auto 0;
        padding: 15px 0;
        border-radius: 25px;
        color: #fff;
        cursor: pointer;
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue